import { setAuthStateSubscriber } from '@agentic-flow-studio/shared/components/layout/AppShell';
import { configureRecentPages } from '@agentic-flow-studio/shared/lib/recent-pages-store';
import { setAuthTokenGetter } from '@agentic-flow-studio/shared/lib/trpc';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { betterAuthStateSubscriber, getBetterAuthToken } from './utils/betterAuth';

// Install this portal's Better Auth sources before the shared tRPC client or AppShell renders.
setAuthTokenGetter(getBetterAuthToken);
setAuthStateSubscriber(betterAuthStateSubscriber);

// Namespaces the command palette's history in localStorage. Both portals can be served from the
// same origin in dev, so this prefix is what keeps Clinic's history out of Anchor's palette.
configureRecentPages('inbox-clinic');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
